<unity-card>
  <unity-card-body>
    <unity-media-block size="small">
      <span
        media
        style="display: flex; align-items: center; justify-content: center"
      >
        <unity-icon
          size="large"
          [name]="service.icon"
          class="em-u-margin-top"
        ></unity-icon>
      </span>
      <span body>
        <unity-media-block-body-headline>
          {{ service.name }}
        </unity-media-block-body-headline>
        <unity-media-block-body-description>
          {{ service.description }}
        </unity-media-block-body-description>
      </span>
    </unity-media-block>
  </unity-card-body>
  <unity-card-footer>
    <a
      unity-button
      variant="secondary"
      [routerLink]="['/entitlement-service', service.id]"
    >
      Maintain Entitlement
    </a>
  </unity-card-footer>
</unity-card>
